/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Empty_StateInputs */

const en_chat_empty_state = /** @type {(inputs: Chat_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the conversation to dispatch tasks via the LLM.`)
};

const fr_chat_empty_state = /** @type {(inputs: Chat_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence la conversation pour dispatcher des tâches via le LLM.`)
};

const ms_sg2_chat_empty_state = /** @type {(inputs: Chat_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan perbualan untuk melancarkan tugasan melalui LLM.`)
};

/**
* | output |
* | --- |
* | "Start the conversation to dispatch tasks via the LLM." |
*
* @param {Chat_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_empty_state = /** @type {((inputs?: Chat_Empty_StateInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Empty_StateInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_empty_state(inputs)
	if (locale === "fr") return fr_chat_empty_state(inputs)
	return ms_sg2_chat_empty_state(inputs)
});